import { apiKey } from "BaseApi/ApiKey";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";

const DisplayProductPrice = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const [data, setData] = useState({
    columns: [
      {
        label: "Mehsul Adi",
        field: "stockName",
        sort: "asc",
      },
      {
        label: "BarCode",
        field: "barCode",
        sort: "asc",
      },
      {
        label: "Kateqory",
        field: "categoryName",
        sort: "asc",
      },
      {
        label: "Qiymeti",
        field: "displayPrice",
        sort: "asc",
      },
    ],
    rows: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const jwtToken = Cookies.get("token");

        const response = await fetch(`${apiKey}/nam/shops/displayprices`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        if (!response.ok) {
          setError(await response.text());
          return;
        }

        const result = await response.json();
        console.log(result);

        const rowsData = result.productDisplayPrices.map((item) => ({
          stockName: item.stockName ? item.stockName : "test",
          barCode: item.barCode,
          categoryName: item.categoryName,
          displayPrice: item.displayPrice,
        }));
        setData((prevData) => ({
          ...prevData,
          rows: rowsData,
        }));
      } catch (error) {
        setError("Gözlənilməz xəta baş verdi");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [refresh]);

  return (
    <div className="content">
      {loading ? (
        <p className="p-3 text-warning">...Yüklənir</p>
      ) : error ? (
        <p className="p-3 text-danger">Xəta baş verdi: {error}</p>
      ) : (
        <MDBDataTable
          data-bs-theme="dark"
          responsiveMd
          striped
          bordered
          hover
          searchLabel="Axtarış"
          paginationLabel={["Əvvəl", "Növbəti"]}
          data={data}
          btn="primary"
        />
      )}
    </div>
  );
};

export default DisplayProductPrice;
